import { Spinner } from 'components/UI';
import { TableBody } from 'components/UI/V3/Table/Body/TableBody';
import { TableCell } from 'components/UI/V3/Table/Cell/TableCell';
import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { TableHeaderCell } from 'components/UI/V3/Table/HeaderCell/TableHeaderCell';
import { TableRow } from 'components/UI/V3/Table/Row/TableRow';
import { Table } from 'components/UI/V3/Table/Table';
import React from 'react';
import { CampaignRow, DEMO_LOCATIONS, formatCurrency } from '../data/mockData';
import styles from './CampaignsTable.module.scss';

export type CampaignSort = 'spend' | 'roas';

interface CampaignsTableProps {
    campaigns: Array<CampaignRow>;
    sort: CampaignSort;
    loading: boolean;
}

export const CampaignsTable: React.FC<CampaignsTableProps> = props => {
    const rows = [...props.campaigns].sort((row, other) =>
        props.sort === 'spend' ? other.campaign.spend - row.campaign.spend : other.roas - row.roas
    );

    const locationNames = (locationIds: Array<number>) =>
        DEMO_LOCATIONS.filter(location => locationIds.includes(location.id))
            .map(location => location.name)
            .join(', ');

    return (
        <Table firstColumnFixed>
            <TableHeader>
                <TableHeaderCell>Campaign</TableHeaderCell>
                <TableHeaderCell>Spend (30d)</TableHeaderCell>
                <TableHeaderCell>New Clients</TableHeaderCell>
                <TableHeaderCell>Cost per Client</TableHeaderCell>
                <TableHeaderCell>90-Day Revenue</TableHeaderCell>
                <TableHeaderCell>ROAS</TableHeaderCell>
            </TableHeader>
            <TableBody>
                {props.loading && (
                    <tr>
                        <td
                            colSpan={6}
                            className={styles.loadingCell}
                        >
                            <Spinner />
                        </td>
                    </tr>
                )}
                {!props.loading &&
                    rows.map(row => (
                        <TableRow key={row.campaign.id}>
                            <TableCell>
                                <div className={styles.campaignCell}>
                                    <span className={styles.campaignName}>{row.campaign.name}</span>
                                    <span className={styles.campaignLocations}>
                                        {locationNames(row.campaign.locationIds)}
                                    </span>
                                </div>
                            </TableCell>
                            <TableCell>{formatCurrency(row.campaign.spend)}</TableCell>
                            <TableCell>{row.campaign.newClients}</TableCell>
                            <TableCell>{row.campaign.newClients === 0 ? '—' : formatCurrency(row.cpa)}</TableCell>
                            <TableCell>{formatCurrency(row.revenue90d)}</TableCell>
                            <TableCell className={styles.roasCell}>{`${row.roas.toFixed(1)}x`}</TableCell>
                        </TableRow>
                    ))}
            </TableBody>
        </Table>
    );
};

export default CampaignsTable;
